import React from 'react';

import convertSpotifyWebLinkToNative from '../helpers/spotifyWebLinkToNative';

function WorksByRecentlyAdded({composers, nativeLinks}) {
  const worksOfComposers = [];

  const composersWithWorksByEra = composers.map((era) => {
    const eraComposersWithWorks = era.composers.filter((composer) => {
      return Array.isArray(composer.works) && composer.works.length > 0;
    })

    return [
      ...eraComposersWithWorks,
    ]
  })

  composersWithWorksByEra.forEach((eraComposersWithWorks) => {
    // iterate through eraComposersWithWorks
    eraComposersWithWorks.forEach((eraComposerWithWorks) => {
      // for each work, add to running list of works
      eraComposerWithWorks.works.forEach((work) => {
        worksOfComposers.push({
          composerName: eraComposerWithWorks.name,
          work,
        })
      })
    })
  })

  worksOfComposers.sort((a, b) => {
    if (a.work.dateAddedToJSON > b.work.dateAddedToJSON) {
      return -1;
    }
    if (a.work.dateAddedToJSON < b.work.dateAddedToJSON) {
      return 1;
    }
    // a must be equal to b
    return 0;
  });

  const worksOfComposersByRecentlyAdded = worksOfComposers.map((workByComposer, index) => {

    const favoriteMovements = workByComposer.work.favoriteMovements.map((fav, index) => {
      return <li key={`${workByComposer.composerName}-favorite-${index}`}>{fav}</li>
    })

    return (
      <li className="recentlyAddedWork" key={`recentlyAddedWork-${index}`}>
        {/* composer name - small text on top */}
        <div>{workByComposer.composerName}</div>

        {/* piece title ! */}
        <div className="workText">
          {
            workByComposer.work.favorite ?
              <span role="img" className="favoriteIcon" aria-label="favoriteIcon">⭐</span>
              : <span className="favoriteIcon"></span>
          }
          {/* NOTE: THIS is the LINK on the "recently added" page */}
          <a href={convertSpotifyWebLinkToNative(workByComposer.work.links[0].link, nativeLinks)}>{workByComposer.work.title}</a>
        </div>

        {/* * favorite notes */}
        <ul className="favoriteMovements">{favoriteMovements}</ul>

        {/* date added */}
        <div>Added on {workByComposer.work.dateAddedToJSON}</div>
        <hr/>
      </li>
    )
  });

  return (
    <div>
      <div>Works by Recently Added</div>
      <hr/>
      <ul>{worksOfComposersByRecentlyAdded}</ul>
    </div>
  )
}

export default WorksByRecentlyAdded;
